import React, { useEffect, useState } from "react";
import { LOAD_AREAS_LIST } from "../../utils/apiPath";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import StudentSignup2 from "../StudentSignUp/StudentSignup2";
import PropTypes from "prop-types";

const MentorSignUp2 = (props) => {

  const { title } = props;
  const [areas, setAreas] = useState([]);
  const [settingData, setSettingData] = useState();
  const [selectedArea, setSelectedArea] = useState([]);
  const [mainArea, setMainArea] = useState([]);

  console.log("", selectedArea, areas, mainArea, settingData);

  // Fetching domain list
  const getAreasData = (page = 1) => {
    agent
      .get(LOAD_AREAS_LIST, {})
      .then((res) => {
        setAreas(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingResponse = await agent.get(API.SETTING);
        setSettingData(settingResponse?.data?.data);
      } catch (error) {
        console.error("Failed to load settings", error);
      }
    };

    fetchSettings();
  }, []);

  const getUserId = localStorage.getItem("userId");

  useEffect(() => {
    document.title = title;
    const getSelectedMainAreaData = (page = 1) => {
      agent
        .get(API.GETUSERDATA + "/" + getUserId)
        .then((res) => {
          if (res.data.data.domains) {
            const tempMain = res.data.data.domains.split(",");
            const tempSub = res.data.data.subareas.split(",");
            setMainArea(tempMain);
            setSelectedArea(tempSub);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };
    getSelectedMainAreaData();
    getAreasData();
  }, [title, getUserId]);

  return (
    <StudentSignup2 />
  );
};

MentorSignUp2.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MentorSignUp2;
